export default __webpack_public_path__ + "static/media/img10.f95e630b.svg";